import { useEffect, useRef, MutableRefObject } from "react"

import gsap from "gsap"
import { isBreakpoint } from "styles/breakpoints"

export interface TilesStaggerVars extends gsap.TweenVars {
  stagger?: gsap.StaggerVars
  withStagger?: boolean
  slideInOnMobile?: boolean
}

const useTilesStagger = (
  onScroll = true,
  vars: TilesStaggerVars = { slideInOnMobile: true },
  withStagger = false
): {
  sectionRef: MutableRefObject<HTMLElement | null>
  tilesRefs: MutableRefObject<(HTMLElement | null)[]>
} => {
  const sectionRef = useRef<HTMLElement | null>(null)
  const tilesRefs = useRef([])
  useEffect(() => {
    if (isBreakpoint("md") || !vars.slideInOnMobile) {
      gsap.fromTo(
        tilesRefs.current,
        { y: 200, autoAlpha: 0 },
        {
          duration: 0.5,
          autoAlpha: 1,
          y: 0,
          ...vars,
          // TODO: Some bug there I had not time to investigate, removed in MVP
          // ...(withStagger
          //   ? {
          //       stagger: {
          //         each: 0.15,
          //         from: "random",
          //         ...vars?.stagger,
          //       },
          //     }
          //   : {}),
          scrollTrigger: onScroll
            ? { trigger: sectionRef.current as HTMLElement, start: "top 80%" }
            : undefined,
        }
      )
    } else {
      tilesRefs.current.forEach(tile => {
        gsap.fromTo(
          tile,
          { xPercent: -100, autoAlpha: 0 },
          {
            duration: 0.3,
            autoAlpha: 1,
            xPercent: 0,
            ease: "slow(0.7, 0.7, false)",
            ...vars,
            scrollTrigger: { trigger: tile, start: "top 80%", once: true },
          }
        )
      })
    }
  }, [onScroll, vars])

  return { sectionRef, tilesRefs }
}

export default useTilesStagger
